import Vue from 'vue'
import Router from 'vue-router'

const Home = () => import("@/page/Home")

Vue.use(Router)

export default new Router({
    // mode: 'history',
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js